(function() {
  if ($.fn.editableutils) {
    const original = $.fn.editableutils.setCursorPosition;
    $.fn.editableutils.setCursorPosition = function() {
      try {
        original.apply(this, Array.prototype.slice.call(arguments));
      } catch (e) { /* noop */ }
    };
  }
})();